"use strict";

define('rs/header/header.controller',['vertebrae', 'rs/header/header.view'], function (Vertebrae, HeaderView) {
  var HeaderController = Vertebrae.Controller.extend({
    properties: ['User', 'appController'],
    initialize: function initialize(appController) {
      this._super();
      this.appController = appController;
      this.setUser(appController.getUser());
    },
    setupView: function setupView() {
      this.setView(new HeaderView());
    },
    getApplicationLinks: function getApplicationLinks() {
      return this.getAppController().getApplicationLinks();
    },
    routeDidChange: function routeDidChange(route) {
      this.getView().selectActiveNavByIndex(this.getActiveNavigation(route));
    },
    requestNavRoute: function requestNavRoute(route) {
      this.getAppController().navigate(route, {
        trigger: true
      });
    },
    requestLogout: function requestLogout() {
      this.getAppController().requestLogout();
    },
    getActiveNavigation: function getActiveNavigation(route) {
      var navs = this.getNavigationLinks(),
        len = navs.length,
        i = j = 0;
      for (i = 0; i < len; i++) {
        var link = navs[i];
        if (link.route && this.compareRoutes(link.route, route)) {
          return i;
        } else if (link.children) {
          for (j = 0; j < link.children.length; j++) {
            var subLink = link.children[j];
            if (this.compareRoutes(subLink.link.slice(1), route)) {
              return i;
            }
          }
        }
      }
      return 0;
    },
    compareRoutes: function compareRoutes(route, activeRoute) {
      var partialIndex = route.indexOf('/'),
        partialRoute = route.slice(0, partialIndex);
      return activeRoute.indexOf(partialRoute) > -1;
    },
    getNavigationLinks: function getNavigationLinks() {
      return this.getAppController().getNavigationLinks();
    },
    getTemplateProperties: function getTemplateProperties() {
      var user = this.getUser(),
        navs = this.getNavigationLinks();
      return {
        navWidth: 100 / navs.length + '%',
        navigationLinks: navs,
        user: user.getDisplayName(),
        app: this.appController.getView().getCurrentApp(),
        badges: this.badges,
        notifications: this.getAppController().hasNotifications()
      };
    },
    getSearchResults: function getSearchResults(qStr) {
      alert('Searching for string "' + qStr + '" is not implemented yet!');
    },
    getBadgePositions: function getBadgePositions() {
      var badges = this.badges,
        view = this.getView(),
        badge = null,
        positions = [],
        len = badges ? badges.length : 0,
        i = 0;
      for (i = 0; i < len; ++i) {
        badge = badges[i];
        positions.push({
          name: badge.name,
          position: view.getBadgePosition(badge.name) || {}
        });
      }
      return positions;
    },
    getBadgePosition: function getBadgePosition(name) {
      return this.getView().getBadgePosition(name);
    },
    setBadgeCount: function setBadgeCount(name, count) {
      if (count) {
        this.getView().showBadgeCount(name);
        this.getView().setBadgeCount(name, count);
      } else {
        this.getView().hideBadgeCount(name);
      }
    },
    requestBadgeToggle: function requestBadgeToggle(name) {
      var appController = this.getAppController();
      appController.setNotificationsOpen(!appController.getNotificationsOpen());
    }
  });
  return HeaderController;
});

